
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z","fill":"#00AF87"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21 8.664h-2.992C16.477 7.641 14.39 7 12 7c-2.39 0-4.617.64-6.148 1.664H3c.469.547.813 1.281.898 1.79a4.476 4.476 0 003.617 7.11c1.407-.002 2.665-.642 3.485-1.658.336.39.89 1.18 1 1.406.64-.96 1.008-1.398 1.008-1.398a4.464 4.464 0 003.476 1.649 4.476 4.476 0 003.618-7.11c.085-.508.43-1.242.898-1.789zm-9-.922c1.602 0 3.055.305 4.344.867A4.475 4.475 0 0012 13.086c0-2.477-2-4.477-4.477-4.484 1.282-.555 2.875-.86 4.477-.86zm-.875 5.344a3.611 3.611 0 00-3.61-3.61 3.61 3.61 0 000 7.22 3.61 3.61 0 003.61-3.61zm5.352 2.148c1.203 0 2.18-.968 2.18-2.171a2.174 2.174 0 00-2.18-2.172 2.172 2.172 0 000 4.343zM9.64 13.07c0 1.203-.97 2.18-2.172 2.18a2.18 2.18 0 01-2.18-2.18c0-1.195.977-2.172 2.18-2.172 1.203 0 2.172.977 2.172 2.172zm6.836-1.515a1.509 1.509 0 010 3.015 1.509 1.509 0 01-1.508-1.508c0-.828.68-1.507 1.508-1.507zm-7.5 1.515c0-.828-.68-1.508-1.508-1.508a1.509 1.509 0 000 3.016c.828 0 1.508-.672 1.508-1.508zm7.39.727a.734.734 0 00.735-.735.727.727 0 00-.735-.726.727.727 0 00-.734.726c0 .407.328.735.734.735zm-9.008.008a.73.73 0 10-.007-1.461.73.73 0 00.007 1.46zm12.727-.72a3.604 3.604 0 10-7.211 0 3.604 3.604 0 107.21 0z","fill":"#fff"}})])
          )
        }
      }
    